module.exports = __webpack_public_path__ + "fonts/firacode-bold.45d8bf7.eot";